import { retrieveSessoCavallo, retrieveSiglaMantello } from 'features/ippica/functions';
import { useGetCavallo } from 'features/ippica/hooks';
import { IppicaInfoListItem } from '../../ippicaInfoListItem';
import styles from './IppicaScommesseTableInfoList.module.scss';

export type IppicaScommesseTableInfoListProps = {
  containerClassName?: string;
  keyCavallo: string;
};

export const IppicaScommesseTableInfoList = ({ containerClassName, keyCavallo }: IppicaScommesseTableInfoListProps) => {
  const {
    anni,
    sesso,
    codiceMantello,
    finimenti,
    ultimePrestazioni,
    allenatore,
    proprietario,
    nomeCavalloMadre,
    nomeCavalloPadre,
  } = useGetCavallo(keyCavallo);
  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <ul className={styles.list}>
        {anni && (
          <IppicaInfoListItem title={'età'} textType={'medium'} className={styles.item}>
            {anni} anni
          </IppicaInfoListItem>
        )}
        {sesso && (
          <IppicaInfoListItem title={'sesso'} textType={'medium'} className={styles.item}>
            {retrieveSessoCavallo(sesso)}
          </IppicaInfoListItem>
        )}

        {(codiceMantello || codiceMantello !== 0) && (
          <IppicaInfoListItem title={'mantello'} textType={'medium'} className={styles.item}>
            {retrieveSiglaMantello(codiceMantello)}
          </IppicaInfoListItem>
        )}
        {finimenti && (
          <IppicaInfoListItem title={'finimenti'} textType={'medium'} className={styles.item}>
            {finimenti}
          </IppicaInfoListItem>
        )}
        {ultimePrestazioni && (
          <IppicaInfoListItem title={'ultime prestazioni'} textType={'medium'} className={styles.item}>
            {ultimePrestazioni}
          </IppicaInfoListItem>
        )}
        {allenatore && (
          <IppicaInfoListItem title={'allenatore'} textType={'medium'} className={styles.item}>
            {allenatore}
          </IppicaInfoListItem>
        )}
        {proprietario && (
          <IppicaInfoListItem title={'proprietario'} textType={'medium'} className={styles.item}>
            {proprietario}
          </IppicaInfoListItem>
        )}
        {nomeCavalloMadre && (
          <IppicaInfoListItem title={'nome cavallo madre'} textType={'medium'} className={styles.item}>
            {nomeCavalloMadre}
          </IppicaInfoListItem>
        )}
        {nomeCavalloPadre && (
          <IppicaInfoListItem title={'nome cavallo padre'} textType={'medium'} className={styles.item}>
            {nomeCavalloPadre}
          </IppicaInfoListItem>
        )}
      </ul>
    </div>
  );
};
